import type { ClassicalListViewPage } from '@jet-app/music-classical/api/types';
import {
    fixArtwork,
    type Page,
    type PageHeader,
} from '@jet-app/music-classical/models';
import type { LibraryPlaylistsItems } from '@jet-app/music-classical/models/pages/library/playlist';
import { createFlowActionForItem } from '@jet-app/music-classical/utilities/create-flow-action';
import { type ObjectGraph } from '@jet/environment/dependencies';

export function renderLibraryPlaylistsItems(
    apiResponse: ClassicalListViewPage,
    objectGraph: ObjectGraph,
): LibraryPlaylistsItems {
    const playlistItems =
        apiResponse.firstPage?.items?.map((item: any) => {
            return {
                id: { type: 'playlist', resourceId: item?.id },
                label: item?.title,
                artwork: fixArtwork(item?.image),
                segue: createFlowActionForItem(item, objectGraph),
                canEdit: item?.canEdit,
            };
        }) || [];
    return {
        kind: 'LibraryPlaylistsItems',
        pageKind: 'componentScreen',
        header: {} as unknown as PageHeader,
        sections: [],
        items: playlistItems,
    };
}
